import { createClient } from '@sanity/client';

const client = createClient({
  projectId: 'rqugaz2t',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2021-03-25',
});

export default client;
